<template>
  <div class="Maxbox">
    <div class="content">
      <div class="bady">
        <div class="imgs"><img src="./images/submit.png" alt="" /></div>
        <div class="title">你的问卷已提交成功，后续可联系老师进行线下咨询</div>
        <div class="btn" @click="goSas()"><button>我知道了</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XTsubmit",

  data() {
    return {};
  },

  mounted() {},

  methods: {
    goSas() {
      this.$router.push("/studyabroad");
    },
  },
};
</script>

<style lang="less" scoped>
.Maxbox {
  width: 100%;
  height: 1045px;
  background-color: #fff;
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80%;
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    .bady {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        width: 92px;
        height: 92px;
        img {
          width: 100%;
        }
      }
      .title {
        margin-top: 34px;
        margin-bottom: 114px;
        font-size: 18px;
        color: #333;
      }
      .btn {
        button {
          cursor: pointer;
          width: 150px;
          height: 52px;
          background: #3964e6;
          border-radius: 3px 3px 3px 3px;
          opacity: 1;
          color: #fff;
          font-size: 20px;
          text-align: center;
          line-height: 42px;
          border: 0;
        }
      }
    }
  }
}
</style>